module.exports = "\n<main style=\"width:100%;height:100%\">\n    <router-outlet></router-outlet>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/administration-main/administration-main.html
// module id = ZYgR
// module chunks = 0